import {Component, input} from '@angular/core';
import {PlanningRegion} from "../../../../../models/planning_region.model";
import {NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";
import {
  PlanningRegionEmptyCellComponent
} from "../planning-region-row/planning-region-empty-cell/planning-region-empty-cell.component";
import {NgClass} from "@angular/common";

@Component({
  selector: '[app-planning-region-empty-row]',
  standalone: true,
  imports: [
    PlanningRegionEmptyCellComponent,
    NgClass
  ],
  templateUrl: './planning-region-empty-row.component.html',
  styleUrl: './planning-region-empty-row.component.scss'
})
export class PlanningRegionEmptyRowComponent {
  data = input.required<PlanningRegion>()
  dateValue = input.required<NgbDateStruct>()
  wednesday = input.required<string>()
}
